<div>Are you having problems validating your address? <a href="#" (click)="addressFactory.confirmAndSetGeneralDelivery(addressObject)">Click here</a>.</div>
